import { gql } from '@apollo/client';

const GET_ME = gql`
  query getMe(
    $settingsWhere: UserSettingsWhereInput!
    $toursSettingsWhere: ToursSettingsWhereInput!
  ) {
    me {
      id
      firstName
      lastName
      avatarUrl
      licenseUsage {
        assignedCount
        productId
        productCurriculumId
        productCurriculum {
          id
          name
          gradeLevel
          defaultGradeLevel
          code
        }
      }
      dateCreated
      dateRemoved
      dateUpdated
      settings(where: $settingsWhere) {
        appId
        setting
        value
      }
      toursSettings(where: $toursSettingsWhere) {
        tourId
        tour {
          name
        }
        tourStepSettings {
          tourStepId
          viewed
        }
      }
    }
  }
`;

export default GET_ME;
